import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { ContractCustomerService } from './contract-customer.service';

const service = new ContractCustomerService();

export interface ContractCustomerState {}

const ContractCustomerStore: Module<ContractCustomerState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getContractCustomers(context, query?: LocationQuery) {
         return await service.getContractCustomers(query);
      },
   },
};

export default ContractCustomerStore;
